import { Button, Grid, TextField } from "@mui/material";
import { Box, useTheme } from "@mui/system";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { addPost } from "../api";
import { getPosts } from "../redux/postSlice";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { useForm } from "react-hook-form";
import { nanoid } from "nanoid";

export default function AddPost() {
  const dispatch = useDispatch();
  const theme = useTheme();

  const [data, setData] = useState([]);
  const [inputError, setInputError] = useState("");
  const [postList, setDontPost] = React.useState(false);

  console.log(data);
  // const handleAddPost = async () => {
  //   const data1 = await addPost({ text: data });
  //   if (data1) {
  //     dispatch(getPosts());
  //     setData([]);
  //   }
  // };

  const handleAddPost = async () => {
    if (postList) {
      const data1 = await addPost({ text: data });
      if (data1) {
        dispatch(getPosts());
        setData([]);
      }
    }
  };

  const deleteItem = (id) => {
    setData(data.filter((x) => x.id !== id));
  };
  const handleEnd = (result) => {
    console.log(result);
    if (!result.destination) return; //if no destination exits(cancel event), exit this function
    const items = Array.from(data);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
    setData(items);
  };
  const { register, handleSubmit } = useForm();

  const onSubmit = (input) => {
    const id = nanoid();
    if (input.name !== "" && input.name.length >= 5) {
      setDontPost(true);
      setInputError("");
      setData([...data, { id, name: input.name }]);
    } else {
      setInputError("List items should atleast have 5 character");
      setDontPost(false);
    }
  };

  return (
    <Box padding="1rem 1rem 0 1rem" borderBottom="1px solid #ccc">
      <Grid container>
        {/* <Grid item sx={{ paddingRight: "1rem" }}>
          <img src="/logo.png" alt="lgogo" width="50px" />
        </Grid> */}
        <Grid item flexGrow="1">
          <div>
            <form onSubmit={handleSubmit(onSubmit)}>
              <>
                <TextField
                  error={inputError ? true : false}
                  helperText={inputError}
                  disableUnderline
                  sx={{ width: "70%" }}
                  placeholder="Post your bucket list"
                  type="text"
                  autoComplete="off"
                  {...register("name")}
                />
              </>
              <Button sx={{ m: 1 }} component="label">
                Add
                <input hidden type="submit" value="Add" />
              </Button>
            </form>
          </div>
          <div>
            <DragDropContext onDragEnd={handleEnd}>
              <Droppable droppableId="to-dos">
                {(provided) => (
                  <ul {...provided.droppableProps} ref={provided.innerRef}>
                    {data.map((item, index) => (
                      <Draggable
                        key={item.id}
                        draggableId={item.id.toString()}
                        index={index}
                      >
                        {(provided, snapshot) => (
                          <li
                            {...provided.draggableProps}
                            ref={provided.innerRef}
                            {...provided.dragHandleProps}
                            key={item.id}
                            className={
                              snapshot.isDragging ? "selected" : "not-selected"
                            }
                          >
                            {item.name}
                            <Button
                              size="small"
                              sx={{ ml: "20%" }}
                              onClick={() => deleteItem(item.id)}
                            >
                              Delete
                            </Button>
                          </li>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </ul>
                )}
              </Droppable>
            </DragDropContext>
          </div>
          <Box
            textAlign="right"
            paddingBottom=".5rem"
            paddingTop=".5rem"
            borderTop="1px solid #ccc"
          >
            <Button
              onClick={handleAddPost}
              variant="contained"
              color="primary"
              sx={{
                borderRadius: theme.shape.borderRadius,
                fontSize: "12px",
              }}
            >
              Post
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}
